module.exports = __webpack_public_path__ + "img/right1.478817a9.png";